export function formatTimestampToDate(t) {
    if (!t) {return t}
    return t.split('T')[0]
}
